import { render, staticRenderFns } from "./price.vue?vue&type=template&id=0887aeca&"
import script from "./price.vue?vue&type=script&lang=ts&"
export * from "./price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports